<section class="pc-props">
  <section
    class="pc-props__panel"
    [class.pc-props__panel--collapsed]="!propsPanelOpen.font"
  >
    <button
      type="button"
      class="pc-props__panel-toggle"
      [attr.aria-expanded]="propsPanelOpen.font"
      (click)="togglePropsPanel('font')"
    >
      <span class="pc-props__panel-title">
        {{ "printCards.fontSectionTitle" | translate }}
      </span>
      <mat-icon class="pc-props__panel-chevron" aria-hidden="true">{{
        propsPanelOpen.font ? "expand_less" : "expand_more"
      }}</mat-icon>
    </button>
    @if (propsPanelOpen.font) {
      <div class="pc-props__panel-body">
        <mat-form-field appearance="outline" class="pc-props__field-control">
          <mat-label>{{ "printCards.fontLabel" | translate }}</mat-label>
          <mat-select
            [value]="fontPresetId"
            (selectionChange)="fontPresetChange.emit($event.value)"
          >
            @for (font of fontPresets; track font.id) {
              <mat-option [value]="font.id">
                @if (font.label) {
                  {{ font.label }}
                } @else if (font.labelKey) {
                  {{ font.labelKey | translate }}
                }
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (!companyBrandFontReady) {
          <p class="pc-props__hint">
            {{ "printCards.companyFontMissing" | translate
            }}<a routerLink="/settings/company">{{
              "printCards.companyFontSettingsLink" | translate
            }}</a>
          </p>
        }
      </div>
    }
  </section>

  <section
    class="pc-props__panel"
    [class.pc-props__panel--collapsed]="!propsPanelOpen.digitalCard"
  >
    <button
      type="button"
      class="pc-props__panel-toggle"
      [attr.aria-expanded]="propsPanelOpen.digitalCard"
      (click)="togglePropsPanel('digitalCard')"
    >
      <span class="pc-props__panel-title">
        {{ "printCards.digitalCardForQr" | translate }}
      </span>
      <mat-icon class="pc-props__panel-chevron" aria-hidden="true">{{
        propsPanelOpen.digitalCard ? "expand_less" : "expand_more"
      }}</mat-icon>
    </button>
    @if (propsPanelOpen.digitalCard) {
      <div class="pc-props__panel-body">
        <app-searchable-select
          class="pc-props__field-control"
          [label]="'printCards.digitalCardForQr' | translate"
          [value]="digitalCardProfileId"
          (valueChange)="digitalCardProfileIdChange.emit($event)"
          [options]="digitalCardTemplates"
          [displayWith]="digitalCardTemplateLabel"
          [valueWith]="digitalCardTemplateValue"
          [emptyLabel]="'background.none' | translate"
          [emptyValue]="null"
        ></app-searchable-select>
      </div>
    }
  </section>

  <section
    class="pc-props__panel"
    [class.pc-props__panel--collapsed]="!propsPanelOpen.sideBackground"
  >
    <button
      type="button"
      class="pc-props__panel-toggle"
      [attr.aria-expanded]="propsPanelOpen.sideBackground"
      (click)="togglePropsPanel('sideBackground')"
    >
      <span class="pc-props__panel-title">
        {{ "printCards.sideBackgroundSection" | translate }}
        ·
        {{
          (activeSide === "front"
            ? "printCards.tabFront"
            : "printCards.tabBack"
          ) | translate
        }}
      </span>
      <mat-icon class="pc-props__panel-chevron" aria-hidden="true">{{
        propsPanelOpen.sideBackground ? "expand_less" : "expand_more"
      }}</mat-icon>
    </button>
    @if (propsPanelOpen.sideBackground) {
      <div class="pc-props__panel-body">
    <app-print-color
      [label]="'printCards.layoutBackgroundLabel' | translate"
      [value]="backgroundColor"
      (valueChange)="backgroundColorChange.emit($event)"
    ></app-print-color>
    <mat-form-field
      appearance="outline"
      class="pc-props__field-control"
      [class.pc-props__field-control--with-hint]="
        !mediaImagesLoading && mediaImages.length === 0
      "
    >
      <mat-label>{{ "printCards.mediaLabel" | translate }}</mat-label>
      <mat-select
        [disabled]="mediaImagesLoading"
        [value]="trimmedBackgroundImageUrl"
        (selectionChange)="backgroundImageUrlChange.emit($event.value)"
      >
        <mat-select-trigger>
          @if (trimmedBackgroundImageUrl) {
            <span class="pc-props__bg-trigger">
              @if (mediaFilePreview(trimmedBackgroundImageUrl); as preview) {
                <span class="pc-props__bg-file" aria-hidden="true">
                  <mat-icon>{{ preview.icon }}</mat-icon>
                  <span>{{ preview.label }}</span>
                </span>
              } @else {
                <img
                  [src]="trimmedBackgroundImageUrl"
                  alt=""
                  class="pc-props__bg-thumb"
                  loading="lazy"
                />
              }
              {{ mediaLabel(trimmedBackgroundImageUrl) }}
            </span>
          } @else {
            {{ "printCards.backgroundImageNone" | translate }}
          }
        </mat-select-trigger>
        <mat-option value="">{{
          "printCards.backgroundImageNone" | translate
        }}</mat-option>
        @if (orphanBackgroundImageUrl; as orphan) {
          <mat-option [value]="orphan">
            <span class="pc-props__bg-option">
              @if (mediaFilePreview(orphan); as preview) {
                <span class="pc-props__bg-file" aria-hidden="true">
                  <mat-icon>{{ preview.icon }}</mat-icon>
                  <span>{{ preview.label }}</span>
                </span>
              }
              <span>{{
                "printCards.backgroundImageStoredNotInMedia" | translate
              }}</span>
            </span>
          </mat-option>
        }
        @for (img of mediaImages; track img.imageId) {
          <mat-option [value]="img.imageUrl">
            <span class="pc-props__bg-option">
              @if (mediaFilePreview(img.imageUrl); as preview) {
                <span class="pc-props__bg-file" aria-hidden="true">
                  <mat-icon>{{ preview.icon }}</mat-icon>
                  <span>{{ preview.label }}</span>
                </span>
              } @else {
                <img [src]="img.imageUrl" alt="" class="pc-props__bg-thumb" />
              }
              <span>{{ img.name }}</span>
            </span>
          </mat-option>
        }
      </mat-select>
      @if (!mediaImagesLoading && mediaImages.length === 0) {
        <mat-hint>{{
          "printCards.backgroundImageMediaEmptyHint" | translate
        }}</mat-hint>
      }
    </mat-form-field>
      </div>
    }
  </section>

  <section
    class="pc-props__panel"
    [class.pc-props__panel--collapsed]="!propsPanelOpen.properties"
  >
    <button
      type="button"
      class="pc-props__panel-toggle"
      [attr.aria-expanded]="propsPanelOpen.properties"
      (click)="togglePropsPanel('properties')"
    >
      <span class="pc-props__panel-title">
        {{ "printCards.propertiesTitle" | translate }}
      </span>
      <mat-icon class="pc-props__panel-chevron" aria-hidden="true">{{
        propsPanelOpen.properties ? "expand_less" : "expand_more"
      }}</mat-icon>
    </button>
    @if (propsPanelOpen.properties) {
      <div class="pc-props__panel-body">
    @if (!element) {
      <p class="pc-props__empty">
        {{ "printCards.propertiesEmpty" | translate }}
      </p>
    } @else {
      <mat-form-field appearance="outline" class="pc-props__field-control">
        <mat-label>{{ "printCards.elementNameLabel" | translate }}</mat-label>
        <input
          matInput
          type="text"
          [value]="fieldValue('name', elementName)"
          (input)="onFieldInput('name', $any($event.target).value)"
          (blur)="onFieldBlur('name', $any($event.target).value)"
        />
      </mat-form-field>

      <div class="pc-props__grid">
        <mat-form-field appearance="outline" class="pc-props__field-control">
          <mat-label>X</mat-label>
          <input
            matInput
            type="number"
            step="0.05"
            [value]="fieldValue('xCm', visualXCm)"
            (input)="onFieldInput('xCm', $any($event.target).value)"
            (blur)="onFieldBlur('xCm', $any($event.target).value)"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="pc-props__field-control">
          <mat-label>Y</mat-label>
          <input
            matInput
            type="number"
            step="0.05"
            [value]="fieldValue('yCm', visualYCm)"
            (input)="onFieldInput('yCm', $any($event.target).value)"
            (blur)="onFieldBlur('yCm', $any($event.target).value)"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="pc-props__field-control">
          <mat-label>W</mat-label>
          <input
            matInput
            type="number"
            min="0"
            step="0.05"
            [value]="fieldValue('widthCm', element.widthCm)"
            (input)="onFieldInput('widthCm', $any($event.target).value)"
            (blur)="onFieldBlur('widthCm', $any($event.target).value)"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="pc-props__field-control">
          <mat-label>H</mat-label>
          <input
            matInput
            type="number"
            min="0"
            step="0.05"
            [value]="fieldValue('heightCm', element.heightCm)"
            (input)="onFieldInput('heightCm', $any($event.target).value)"
            (blur)="onFieldBlur('heightCm', $any($event.target).value)"
          />
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="pc-props__field-control pc-props__field-control--span"
        >
          <mat-label>{{
            "printCards.elementRotationLabel" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            step="1"
            min="-180"
            max="180"
            [value]="fieldValue('rotationDeg', element.rotationDeg || 0)"
            (input)="onFieldInput('rotationDeg', $any($event.target).value)"
            (blur)="onFieldBlur('rotationDeg', $any($event.target).value)"
          />
        </mat-form-field>
      </div>

      @if (element.type === "text") {
        @if (showsVariableSelect) {
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{
              "printCards.elementVariableLabel" | translate
            }}</mat-label>
            <mat-select
              [value]="element.variable || ''"
              (selectionChange)="patchElement.emit({ variable: $event.value })"
            >
              <mat-option value="" disabled>
                {{ "printCards.elementVariablePlaceholder" | translate }}
              </mat-option>
              @for (variable of variableOptions; track variable) {
                <mat-option [value]="variable">{{ variable }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (showsTextContent) {
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{ "printCards.elementTextLabel" | translate }}</mat-label>
            <textarea
              matInput
              rows="3"
              [value]="fieldValue('text', element.text || '')"
              (input)="onFieldInput('text', $any($event.target).value)"
              (blur)="onFieldBlur('text', $any($event.target).value)"
            ></textarea>
          </mat-form-field>
          <button
            type="button"
            mat-stroked-button
            class="pc-props__field-control"
            (click)="openDomainVariablesDialog()"
          >
            <mat-icon>data_object</mat-icon>
            {{ "printCards.domainVariablesButton" | translate }}
          </button>
        }
        @if (!isSquashElement) {
          <div class="pc-props__grid">
            <mat-form-field appearance="outline" class="pc-props__field-control">
              <mat-label>{{
                "printCards.elementSizeLabel" | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                min="0"
                step="0.5"
                [value]="
                  fieldValue(
                    'fontSizePt',
                    element.fontSizePt || defaultFontSizePt
                  )
                "
                (input)="onFieldInput('fontSizePt', $any($event.target).value)"
                (blur)="onFieldBlur('fontSizePt', $any($event.target).value)"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="pc-props__field-control">
              <mat-label>{{
                "printCards.lineHeightLabel" | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                min="0"
                step="0.05"
                [value]="fieldValue('lineHeight', lineHeightValue)"
                (input)="onFieldInput('lineHeight', $any($event.target).value)"
                (blur)="onFieldBlur('lineHeight', $any($event.target).value)"
              />
            </mat-form-field>
          </div>
        }
        @if (!isSquashElement) {
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{
              "printCards.elementWeightLabel" | translate
            }}</mat-label>
            <mat-select
              [value]="element.fontWeight || 400"
              (selectionChange)="onWeight($event.value)"
            >
              @for (weight of fontWeights; track weight) {
                <mat-option [value]="weight">
                  {{ "printCards.fontWeight." + weight | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <app-print-color
            [label]="'printCards.layoutTextColorLabel' | translate"
            [value]="element.color || '#000000'"
            (valueChange)="onColor($event)"
          ></app-print-color>
          <label class="pc-props__check">
            <input
              type="checkbox"
              [checked]="!!element.italic"
              (change)="
                patchElement.emit({ italic: $any($event.target).checked })
              "
            />
            {{ "printCards.elementItalicShort" | translate }}
          </label>
          <label class="pc-props__check">
            <input
              type="checkbox"
              [checked]="!!element.uppercase"
              (change)="
                patchElement.emit({ uppercase: $any($event.target).checked })
              "
            />
            {{ "printCards.elementUppercaseShort" | translate }}
          </label>
        }
        <div class="pc-props__grid">
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{ "printCards.propertiesAlign" | translate }}</mat-label>
            <mat-select
              [value]="elementAlignValue"
              (selectionChange)="onAlign($event.value)"
            >
              @for (align of aligns; track align) {
                <mat-option [value]="align">
                  {{ "printCards.align." + align | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{
              "printCards.propertiesValign" | translate
            }}</mat-label>
            <mat-select
              [value]="elementValignValue"
              (selectionChange)="onValign($event.value)"
            >
              @for (valign of valigns; track valign) {
                <mat-option [value]="valign">
                  {{ "printCards.valign." + valign | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="pc-props__field-control">
          <mat-label>{{ "printCards.textFitLabel" | translate }}</mat-label>
          <mat-select
            [value]="textFitValue"
            (selectionChange)="onTextFit($event.value)"
          >
            @for (fit of textFits; track fit) {
              <mat-option [value]="fit">
                {{ "printCards.textFit." + fit | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="pc-props__field-control">
          <mat-label>{{ "printCards.maxLinesLabel" | translate }}</mat-label>
          <input
            matInput
            type="number"
            min="1"
            [max]="20"
            step="1"
            [value]="fieldValue('maxLines', maxLinesValue)"
            [placeholder]="'printCards.maxLinesUnlimited' | translate"
            (input)="onFieldInput('maxLines', $any($event.target).value)"
            (blur)="onFieldBlur('maxLines', $any($event.target).value)"
          />
        </mat-form-field>
        @if (textFitValue === "shrink") {
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{
              "printCards.minFontSizeLabel" | translate
            }}</mat-label>
            <input
              matInput
              type="number"
              min="0"
              [max]="minFontSizePtCeiling"
              step="0.5"
              [value]="fieldValue('minFontSizePt', minFontSizeValue)"
              (input)="onFieldInput('minFontSizePt', $any($event.target).value)"
              (blur)="onFieldBlur('minFontSizePt', $any($event.target).value)"
            />
          </mat-form-field>
        }
        <label class="pc-props__check">
          <input
            type="checkbox"
            [checked]="!!element.reversed"
            (change)="onReverse($any($event.target).checked)"
          />
          {{ "printCards.elementReverseLabel" | translate }}
        </label>
      }

      @if (element.type === "logo" || element.type === "image") {
        <div class="pc-props__grid">
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{ "printCards.propertiesAlign" | translate }}</mat-label>
            <mat-select
              [value]="elementAlignValue"
              (selectionChange)="onAlign($event.value)"
            >
              @for (align of aligns; track align) {
                <mat-option [value]="align">
                  {{ "printCards.align." + align | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{
              "printCards.propertiesValign" | translate
            }}</mat-label>
            <mat-select
              [value]="elementValignValue"
              (selectionChange)="onValign($event.value)"
            >
              @for (valign of valigns; track valign) {
                <mat-option [value]="valign">
                  {{ "printCards.valign." + valign | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field
          appearance="outline"
          class="pc-props__field-control"
          [class.pc-props__field-control--with-hint]="
            !mediaImagesLoading && mediaImages.length === 0
          "
        >
          <mat-label>{{
            "printCards.elementImageSource" | translate
          }}</mat-label>
          <mat-select
            [disabled]="mediaImagesLoading"
            [value]="mediaSourceValue"
            (selectionChange)="onMediaSource($event.value)"
          >
            <mat-select-trigger>
              @if (mediaSourceValue) {
                <span class="pc-props__bg-trigger">
                  @if (mediaFilePreview(mediaSourceValue); as preview) {
                    <span class="pc-props__bg-file" aria-hidden="true">
                      <mat-icon>{{ preview.icon }}</mat-icon>
                      <span>{{ preview.label }}</span>
                    </span>
                  } @else {
                    <img
                      [src]="mediaSourceValue"
                      alt=""
                      class="pc-props__bg-thumb"
                      loading="lazy"
                    />
                  }
                  {{ mediaLabel(mediaSourceValue) }}
                </span>
              } @else if (element.type === "logo") {
                {{ "printCards.elementLogoCompany" | translate }}
              } @else {
                {{ "printCards.backgroundImageNone" | translate }}
              }
            </mat-select-trigger>
            @if (element.type === "logo") {
              <mat-option value="">{{
                "printCards.elementLogoCompany" | translate
              }}</mat-option>
            } @else {
              <mat-option value="">{{
                "printCards.backgroundImageNone" | translate
              }}</mat-option>
            }
            @if (orphanMediaSourceUrl; as orphan) {
              <mat-option [value]="orphan">
                <span class="pc-props__bg-option">
                  @if (mediaFilePreview(orphan); as preview) {
                    <span class="pc-props__bg-file" aria-hidden="true">
                      <mat-icon>{{ preview.icon }}</mat-icon>
                      <span>{{ preview.label }}</span>
                    </span>
                  }
                  <span>{{
                    "printCards.backgroundImageStoredNotInMedia" | translate
                  }}</span>
                </span>
              </mat-option>
            }
            @for (img of mediaImages; track img.imageId) {
              <mat-option [value]="img.imageUrl">
                <span class="pc-props__bg-option">
                  @if (mediaFilePreview(img.imageUrl); as preview) {
                    <span class="pc-props__bg-file" aria-hidden="true">
                      <mat-icon>{{ preview.icon }}</mat-icon>
                      <span>{{ preview.label }}</span>
                    </span>
                  } @else {
                    <img
                      [src]="img.imageUrl"
                      alt=""
                      class="pc-props__bg-thumb"
                    />
                  }
                  <span>{{ img.name }}</span>
                </span>
              </mat-option>
            }
          </mat-select>
          @if (!mediaImagesLoading && mediaImages.length === 0) {
            <mat-hint>{{
              "printCards.backgroundImageMediaEmptyHint" | translate
            }}</mat-hint>
          }
        </mat-form-field>
        <label class="pc-props__check">
          <input
            type="checkbox"
            [checked]="!!element.reversed"
            (change)="onReverse($any($event.target).checked)"
          />
          {{ "printCards.elementReverseLabel" | translate }}
        </label>
      }

      @if (element.type === "nfc") {
        <app-print-color
          [label]="'printCards.nfcColorLabel' | translate"
          [value]="element.color || '#000000'"
          (valueChange)="onColor($event)"
        ></app-print-color>
        <label class="pc-props__check">
          <input
            type="checkbox"
            [checked]="!!element.reversed"
            (change)="onReverse($any($event.target).checked)"
          />
          {{ "printCards.elementReverseLabel" | translate }}
        </label>
      }

      @if (element.type === "qr") {
        <label class="pc-props__check">
          <input
            type="checkbox"
            [checked]="!!element.reversed"
            (change)="onReverse($any($event.target).checked)"
          />
          {{ "printCards.elementReverseLabel" | translate }}
        </label>
      }

      @if (element.type === "shape") {
        <app-print-color
          [label]="'printCards.propertiesFill' | translate"
          [value]="element.fill || '#EEEEEE'"
          (valueChange)="onFill($event)"
        ></app-print-color>
        <label class="pc-props__slider">
          <span class="pc-props__slider-label">
            {{ "printCards.elementBorderRadiusLabel" | translate }}
            <strong>{{ element.borderRadiusMm || 0 }} mm</strong>
          </span>
          <input
            type="range"
            min="0"
            max="50"
            step="0.5"
            [value]="
              fieldValue('borderRadiusMm', element.borderRadiusMm || 0)
            "
            (input)="onFieldInput('borderRadiusMm', $any($event.target).value)"
            (change)="onFieldBlur('borderRadiusMm', $any($event.target).value)"
          />
        </label>
      }
    }
      </div>
    }
  </section>

  @if (element?.type === "text" && (isSquashElement || canSquashWithOther)) {
    <section
      class="pc-props__panel"
      [class.pc-props__panel--collapsed]="!propsPanelOpen.squash"
    >
      <button
        type="button"
        class="pc-props__panel-toggle"
        [attr.aria-expanded]="propsPanelOpen.squash"
        (click)="togglePropsPanel('squash')"
      >
        <span class="pc-props__panel-title">
          {{ "printCards.squashSectionTitle" | translate }}
        </span>
        <mat-icon class="pc-props__panel-chevron" aria-hidden="true">{{
          propsPanelOpen.squash ? "expand_less" : "expand_more"
        }}</mat-icon>
      </button>
      @if (propsPanelOpen.squash) {
        <div class="pc-props__panel-body">
      @if (isSquashElement) {
        <div class="pc-props__squash-part">
          <h4 class="pc-props__subheading">
            {{ "printCards.squashSeparatorLabel" | translate }}
          </h4>
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{
              "printCards.elementTextLabel" | translate
            }}</mat-label>
            <input
              matInput
              type="text"
              [value]="fieldValue('squashSeparator', squashSeparatorValue)"
              (input)="
                onFieldInput('squashSeparator', $any($event.target).value)
              "
              (blur)="
                onFieldBlur('squashSeparator', $any($event.target).value)
              "
            />
          </mat-form-field>
          <div class="pc-props__grid">
            <mat-form-field appearance="outline" class="pc-props__field-control">
              <mat-label>{{
                "printCards.elementSizeLabel" | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                min="0"
                step="0.5"
                [value]="
                  fieldValue(
                    'squashSeparatorFontSizePt',
                    squashSeparatorStyle.fontSizePt || defaultFontSizePt
                  )
                "
                (input)="
                  onFieldInput(
                    'squashSeparatorFontSizePt',
                    $any($event.target).value
                  )
                "
                (blur)="
                  onFieldBlur(
                    'squashSeparatorFontSizePt',
                    $any($event.target).value
                  )
                "
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="pc-props__field-control">
              <mat-label>{{
                "printCards.lineHeightLabel" | translate
              }}</mat-label>
              <input
                matInput
                type="number"
                min="0"
                step="0.05"
                [value]="
                  fieldValue(
                    'squashSeparatorLineHeight',
                    squashSeparatorStyle.lineHeight ?? lineHeightValue
                  )
                "
                (input)="
                  onFieldInput(
                    'squashSeparatorLineHeight',
                    $any($event.target).value
                  )
                "
                (blur)="
                  onFieldBlur(
                    'squashSeparatorLineHeight',
                    $any($event.target).value
                  )
                "
              />
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="pc-props__field-control">
            <mat-label>{{
              "printCards.elementWeightLabel" | translate
            }}</mat-label>
            <mat-select
              [value]="squashSeparatorStyle.fontWeight || 400"
              (selectionChange)="onSquashSeparatorWeight($event.value)"
            >
              @for (weight of fontWeights; track weight) {
                <mat-option [value]="weight">
                  {{ "printCards.fontWeight." + weight | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <app-print-color
            [label]="'printCards.layoutTextColorLabel' | translate"
            [value]="squashSeparatorStyle.color || '#000000'"
            (valueChange)="onSquashSeparatorColor($event)"
          ></app-print-color>
          <label class="pc-props__check">
            <input
              type="checkbox"
              [checked]="!!squashSeparatorStyle.italic"
              (change)="
                onSquashSeparatorFlag(
                  'italic',
                  $any($event.target).checked
                )
              "
            />
            {{ "printCards.elementItalicShort" | translate }}
          </label>
          <label class="pc-props__check">
            <input
              type="checkbox"
              [checked]="!!squashSeparatorStyle.uppercase"
              (change)="
                onSquashSeparatorFlag(
                  'uppercase',
                  $any($event.target).checked
                )
              "
            />
            {{ "printCards.elementUppercaseShort" | translate }}
          </label>
        </div>
        @for (part of squashParts; track $index; let partIndex = $index) {
          <div class="pc-props__squash-part">
            <h4 class="pc-props__subheading">
              {{
                "printCards.squashPartTitle"
                  | translate: { name: part.variable, index: partIndex + 1 }
              }}
            </h4>
            <div class="pc-props__grid">
              <mat-form-field
                appearance="outline"
                class="pc-props__field-control"
              >
                <mat-label>{{
                  "printCards.elementSizeLabel" | translate
                }}</mat-label>
                <input
                  matInput
                  type="number"
                  min="0"
                  step="0.5"
                  [value]="
                    fieldValue(
                      'squashFontSizePt-' + partIndex,
                      part.fontSizePt || defaultFontSizePt
                    )
                  "
                  (input)="
                    onFieldInput(
                      'squashFontSizePt-' + partIndex,
                      $any($event.target).value
                    )
                  "
                  (blur)="
                    onFieldBlur(
                      'squashFontSizePt-' + partIndex,
                      $any($event.target).value
                    )
                  "
                />
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="pc-props__field-control"
              >
                <mat-label>{{
                  "printCards.lineHeightLabel" | translate
                }}</mat-label>
                <input
                  matInput
                  type="number"
                  min="0"
                  step="0.05"
                  [value]="
                    fieldValue(
                      'squashLineHeight-' + partIndex,
                      part.lineHeight ?? lineHeightValue
                    )
                  "
                  (input)="
                    onFieldInput(
                      'squashLineHeight-' + partIndex,
                      $any($event.target).value
                    )
                  "
                  (blur)="
                    onFieldBlur(
                      'squashLineHeight-' + partIndex,
                      $any($event.target).value
                    )
                  "
                />
              </mat-form-field>
            </div>
            <mat-form-field
              appearance="outline"
              class="pc-props__field-control"
            >
              <mat-label>{{
                "printCards.elementWeightLabel" | translate
              }}</mat-label>
              <mat-select
                [value]="part.fontWeight || 400"
                (selectionChange)="
                  onSquashPartWeight(partIndex, $event.value)
                "
              >
                @for (weight of fontWeights; track weight) {
                  <mat-option [value]="weight">
                    {{ "printCards.fontWeight." + weight | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <app-print-color
              [label]="'printCards.layoutTextColorLabel' | translate"
              [value]="part.color || '#000000'"
              (valueChange)="onSquashPartColor(partIndex, $event)"
            ></app-print-color>
            <label class="pc-props__check">
              <input
                type="checkbox"
                [checked]="!!part.italic"
                (change)="
                  onSquashPartFlag(
                    partIndex,
                    'italic',
                    $any($event.target).checked
                  )
                "
              />
              {{ "printCards.elementItalicShort" | translate }}
            </label>
            <label class="pc-props__check">
              <input
                type="checkbox"
                [checked]="!!part.uppercase"
                (change)="
                  onSquashPartFlag(
                    partIndex,
                    'uppercase',
                    $any($event.target).checked
                  )
                "
              />
              {{ "printCards.elementUppercaseShort" | translate }}
            </label>
          </div>
        }
        <button
          type="button"
          mat-stroked-button
          class="pc-props__field-control"
          (click)="onUnsquash()"
        >
          {{ "printCards.squashUnsquash" | translate }}
        </button>
      }
      @if (canSquashWithOther) {
        <mat-form-field appearance="outline" class="pc-props__field-control">
          <mat-label>{{ "printCards.squashWithLabel" | translate }}</mat-label>
          <mat-select [(value)]="squashPartnerId">
            @for (target of squashTargets; track target.id) {
              <mat-option [value]="target.id">{{ target.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button
          type="button"
          mat-stroked-button
          class="pc-props__field-control"
          [disabled]="!squashPartnerId"
          (click)="onApplySquash()"
        >
          {{ "printCards.squashApply" | translate }}
        </button>
      }
        </div>
      }
    </section>
  }
</section>
